module.exports = __webpack_public_path__ + "img/samoa.858661b9.svg";